export * from '@s4l/stayforlong/property/schemas/v3/search/legacy'
